import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AddPhotoContainer = styled(Button)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  cursor: "pointer",
  "&:hover": {
    opacity: 0.7,
  },
}));

export const AddIcon = styled(AddCircleOutlineIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.colors.primary.slalomBlue,
}));
